import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeTab: 'bankDetails',
}

const eventSettingsSlice = createSlice({
    name: 'eventSettings',
    initialState,
    reducers: {
        setEventSettingActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
    },
});

export const { setEventSettingActiveTab } = eventSettingsSlice.actions;

export default eventSettingsSlice.reducer;